import styles from 'styles/components/common/elements/Badge.module.scss';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';

type TProps = {
  text: string;
  badgeStyles?: React.CSSProperties;
  onDelete?: () => void;
};

const Badge = ({ text, badgeStyles, onDelete }: TProps) => {
  return (
    <div className={styles.badge_wrapper} style={badgeStyles}>
      <strong>{text}</strong>
      {onDelete && (
        <button type="button" className={styles.delete} onClick={onDelete}>
          <CloseIcon width={16} height={16} fill={STYLES_VARIABLES.GRAY_07} />
        </button>
      )}
    </div>
  );
};

export default Badge;
